<h2 mat-dialog-title class="perse-dialog-title">Share my Data</h2>
<mat-dialog-content #dialogContent>
  <div *ngIf="isNewlyAdded" class="newly-added-message">
    <mat-icon class="info-icon icon-no-shrink">info</mat-icon>
    <p>Data will be fetched and available in 24 hours.</p>
  </div>
  
  <div class="mb-4">
    <p class="meter-info">
      {{ isSingleMeter ? 'Meter Number' : 'Meters' }}: 
      <strong>{{ meterDisplayText }}</strong>
    </p>
    <p class="meter-info" *ngIf="isSingleMeter">
      Address: <strong>{{ primaryMeter.address }}</strong>
    </p>
    <div class="meter-list" *ngIf="!isSingleMeter">
      <p><strong>Addresses:</strong></p>
      <ul>
        <li *ngFor="let meter of data.meters">
          {{ meter.meterNumber }} - {{ meter.address }}
        </li>
      </ul>
    </div>
  </div>

  <form [formGroup]="searchForm" class="search-form">
    <!-- Platform Selector Mode -->
    <div *ngIf="!isAddingNewPlatform">
      <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
        <mat-label>Software Platform</mat-label>
        <mat-select
          formControlName="organization"
          placeholder="Select software platform"
          (selectionChange)="onOrganizationSelected($event.value)">
          <mat-option *ngIf="fetchingOrganizations" disabled>
            <mat-spinner diameter="20"></mat-spinner> Loading...
          </mat-option>
          <mat-option *ngFor="let org of validOrganizations" [value]="org">
            {{org.software}}<span *ngIf="org.isPreferred"> (Requestor)</span>
          </mat-option>
        </mat-select>
        <mat-error *ngIf="searchForm.get('organization')?.hasError('required')">Software platform is required</mat-error>
      </mat-form-field>

      <!-- Can't find platform link -->
      <div *ngIf="!selectedPartner && !fetchingOrganizations" class="cant-find-platform">
        <button type="button" mat-button color="primary" (click)="switchToAddPlatformMode()">
          <mat-icon>add</mat-icon>
          Can't find the platform in list?
        </button>
      </div>
    </div>

    <!-- Add New Platform Mode -->
    <div *ngIf="isAddingNewPlatform">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Add New Platform</mat-label>
        <input
          matInput
          formControlName="newPlatformName"
          placeholder="Enter platform name">
        <mat-error *ngIf="searchForm.get('newPlatformName')?.hasError('required')">Platform name is required</mat-error>
      </mat-form-field>

      <div class="add-platform-actions">
        <button
          type="button"
          mat-button
          (click)="cancelAddPlatform()"
          [disabled]="isAddingOrganization">
          Cancel
        </button>
        <button
          type="button"
          mat-raised-button
          color="primary"
          (click)="addNewPlatform()"
          [disabled]="searchForm.get('newPlatformName')?.invalid || isAddingOrganization">
          <mat-spinner *ngIf="isAddingOrganization" diameter="16"></mat-spinner>
          {{ isAddingOrganization ? 'Adding...' : 'Add Platform' }}
        </button>
      </div>
    </div>
  </form>

  <div *ngIf="selectedPartner" class="partners-found">
    <div class="selected-platform-header">
      <h5>Selected Software Platform</h5>
      <button type="button" mat-icon-button (click)="clearSelectedPlatform()" matTooltip="Clear selection">
        <mat-icon>clear</mat-icon>
      </button>
    </div>

    <div class="partner-card">
      <div class="partner-info">
        <div class="partner-name-container">
          <h4>{{ selectedPartner.software || selectedPartner.name }}</h4>
          <mat-icon class="blue-tick">check_circle</mat-icon>
        </div>
        @if(selectedPartner.software) {
          <p>Organization: {{ selectedPartner.name }}</p>
        }
        @if(selectedPartner.email) {
          <p class="partner-email">{{ selectedPartner.email }}</p>
        }
      </div>
    </div>
  </div>

  <!-- Loading Indicator -->
  <div *ngIf="isLoading" class="spinner-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Processing...</p>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    *ngIf="isConsentRequestMode"
    mat-button
    color="warn"
    (click)="decline()">
    Decline
  </button>
  <button mat-button (click)="onCancel()">
    {{ isConsentRequestMode ? 'Skip' : 'Cancel' }}
  </button>
  <button
    mat-flat-button
    color="primary"
    [disabled]="isSharing || searchForm.invalid"
    (click)="shareWithPartner()">
    <mat-icon>send</mat-icon> Send to Platform
  </button>
</mat-dialog-actions>
